import { render, staticRenderFns } from "./GraphDetail55.vue?vue&type=template&id=2fb577ed&scoped=true"
import script from "./GraphDetail55.vue?vue&type=script&lang=js"
export * from "./GraphDetail55.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb577ed",
  null
  
)

export default component.exports